import React, { Component } from 'react'
import IdleTimer from 'react-idle-timer'
import {connect} from 'react-redux'
import { IAppState } from '../src/store/state.interface.web'
import Main from './Main'
import { logoutUser } from '../src/auth/Login/index.reducer'

class IdleTime extends Component<any> {
  idleTimer: any
  constructor(props: any) {
    super(props)
    this.idleTimer = null
  }

  componentWillReceiveProps(newProps: any) {
    if (!this.props.userId && newProps.userId !== this.props.userId) {
      if (this.idleTimer) {
        this.idleTimer.reset()
      }
    }
  }

  onAction = (e: any) => {
    // console.log('user did something', e)
  }

  onActive = (e: any) => {
    if (!this.idleTimer) {
      return
    }
    // console.log('user is active', e)
    // // @ts-ignore
    // console.log('time remaining', this.idleTimer.getRemainingTime())
  }

  onIdle = (e: any) => {
    if (!this.idleTimer) {
      return
    }
    // console.log('user is idle', e)
    if (this.props.userId) {
      this.props.logoutUser()
    }
  }

  render() {
    return (
      <>
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={1000 * 60 * 30} />
        <Main />
      </>
    )
  }
}

const mapStateToProps = (state: IAppState) => ({
  userId: state.login.user.id
})

// @ts-ignore
const mapDispatchToProps = dispatch => ({
  logoutUser: () => dispatch(logoutUser())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IdleTime)
